import { getApiPlatform } from '@/utils/getPlatform';
import type { TrackingContext } from '@/utils/tracking/_types';
import {
  type WaitlistTimePreference,
  toTrackedTimePreferences,
} from '@/utils/waitlistTimePreferences';

interface StandbyWaitlistEventPropsInput {
  shopId: string;
  timePreferences: WaitlistTimePreference[];
  anyProfessional: boolean;
}

// Shared by the four existing waitlist events; carries no customer details.
export const buildStandbyWaitlistEventProps = ({
  shopId,
  timePreferences,
  anyProfessional,
}: StandbyWaitlistEventPropsInput): TrackingContext => ({
  shopId,
  list_type: 'standby',
  time_preferences: toTrackedTimePreferences(timePreferences),
  any_professional: anyProfessional,
  platform: getApiPlatform(),
});
